import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { MainRequirementFilter } from '../../components/Filter/MainRequirementFilter';
import axios from 'axios';
import { baseUrl } from '../../comman/config';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";

function MainStoreReceiptList() {
  const today = new Date().toISOString().split("T")[0];
  const [ingredientReceiptList, setIngredientReceiptList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [receiptStatus, setReceiptStatus] = useState({});
  const [ingredient, setIngredient] = useState({});
  const [loading, setLoading] = useState(false);
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [category , setCategory] = useState([]);
  
  useEffect(() => {
    getIngredientReceiptList();
  }, [fromDate, toDate, ingredient, receiptStatus])

  const handelFilterChange = async (from_date, to_date, ingredient, category, mainReceiptStatus) => {
    setFromDate(from_date);
    setToDate(to_date);
    setIngredient(ingredient);
    setCategory(category); 
    setReceiptStatus(mainReceiptStatus);
  };

  const getIngredientReceiptList = async() => {
    console.log("ingredient :",ingredient);
    console.log("category in main store:",category);
    console.log("receipt status:",receiptStatus);
    setLoading(true)
    setNoRecordsFound(false)
    try {
      const response = await axios.get(`${baseUrl}/main_receipt/ingredient_list`, {
        params: {
          storeId: 1,
        //   fromDate: fromDate,
        //   toDate: toDate,
        category: category?.value,
          ingredient: ingredient?.value,
          receiptStatus: receiptStatus?.value
        }
      });
      
      const updatedArray = response?.data?.data.map(item => ({
        ...item,
        order_qty: item.order_qty ?? 0, 
        order_pack_nos: item?.order_pack_nos ?? 0,         
        received_qty: item.received_qty ?? "",
        rec_pack_nos: item?.rec_pack_nos ?? 0,
        diff_qty: (item.received_qty - item.order_qty) ?? 0,
        diff_pack: (item.rec_pack_nos - item.order_pack_nos) ?? 0,
        add_received: false,
        add_received_qty: ""
      }));
      
      setIngredientReceiptList(updatedArray);
      setNoRecordsFound(updatedArray.length === 0);
      setSelectedRows([]);
      setSelectAll(false);
    } catch (error) {
      console.error("Error fetching ingredient receipts:", error);
      toast.error("Failed to load receipt data");
    } finally {
      setLoading(false);
    }
  }

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(ingredientReceiptList[index])
        ? selectedRows.filter(item => item !== ingredientReceiptList[index]) // Deselect
        : [...selectedRows, ingredientReceiptList[index]]; // Select

    setSelectedRows(updatedSelectedRows);
  };

  const handleSwitchSelectAll = () => {
    if (selectAll) {
        setSelectedRows([]);
    } else {
        // Select all rows that are eligible for receipt
        setSelectedRows(ingredientReceiptList.filter((item) => 
          item.receipt_status !== 3 || (item.receipt_status === 3 && item.add_received)
        ));
    }
    setSelectAll(!selectAll);
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setIngredientReceiptList((prevFormData) => {
      if(name === 'rec_pack_nos'){
        const updatedFormData = [...prevFormData];
        const order_pack_nos = updatedFormData[index].order_pack_nos;
        const diff_pack = (value - order_pack_nos).toFixed(2);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_pack };
        return updatedFormData;
      } else if(name === 'add_received_qty'){
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
      } else {
        const updatedFormData = [...prevFormData];
        const order_qty = updatedFormData[index].order_qty;
        const diff_qty = (value - order_qty).toFixed(2);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_qty };
        return updatedFormData;
      }
    });
  };

  const handleAddButtonClick = (index) => {
    setIngredientReceiptList((prevFormData) => {
      const updatedFormData = [...prevFormData]
      updatedFormData[index] = {...updatedFormData[index], add_received: true}
      return updatedFormData
    })
  }

  const handleSave = async() => {
    try {
      const itemsToSave = ingredientReceiptList.filter(item => 
        item.received_qty !== "" && item.rec_pack_nos !== ""
      );
      
      if (itemsToSave.length === 0) {
        toast.error("Please enter received quantities before saving");
        return;
      }
      
      const response = await axios.post(`${baseUrl}/main_receipt/ingredient_save`, {
        ingredientsList: itemsToSave
      });
      
      toast.success("Receipt data saved successfully");
      getIngredientReceiptList();
    } catch (error) {
      console.error("Error saving receipt data:", error);
      toast.error("Failed to save receipt data");
    }
  }

  const handleReceived = async() => {
    try {
      if(selectedRows.length === 0){
        toast.error("Please select at least one item to mark as received");
        return;
      }
      
      if(selectedRows.some(item => item.received_qty === "")){
        toast.error("One or more selected items have an empty received quantity value");
        return;
      }
      
      if(selectedRows.some(item => item.receipt_status === 3 && item.add_received && item.add_received_qty === "")){
        toast.error("One or more selected items have an empty additional received quantity value");
        return;
      }
      
      const response = await axios.post(`${baseUrl}/main_receipt/ingredient_purchase`, {
        ingredientsList: selectedRows
      });
      
      toast.success(response.data.msg || "Items marked as received successfully");
      getIngredientReceiptList();
      setSelectedRows([]);
    } catch (error) {
      console.error("Error marking items as received:", error);
      toast.error("Failed to mark items as received");
    }
  }

  return (
    <div className="p-4">
        {loading && <Loader/>}
        <div className="flex justify-between items-center py-4 px-6">
          <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
            Main Store Receipt
          </h1>
          <Toaster position="top-center" reverseOrder={false} />
        </div>
        <div className="relative shadow-md sm:rounded-lg">
          <MainRequirementFilter handleFilterChange={handelFilterChange} page="main_receipt" />
        </div>
        {noRecordsFound && <NoRecordsFound/>}
        {ingredientReceiptList.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-2 py-1 border border-black text-center">
                    <input 
                      type="checkbox" 
                      className="newrow checkboxAll" 
                      onChange={handleSwitchSelectAll} 
                      checked={selectAll} 
                    />
                  </th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Ingredient</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Category</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center" colSpan='2'>Order</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center" colSpan='2'>Received</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Diff Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Diff Pack</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Receipt Status</th>
                </tr>
                <tr>
                  <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Pack Nos.</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center">Pack Nos.</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                </tr>
              </thead>
              <tbody>
                {ingredientReceiptList.map((item, index) => (
                  <tr key={index} className="border border-black-b">
                    <td className="px-2 py-1 border border-black text-center">
                      <input 
                        type="checkbox" 
                        checked={selectedRows.includes(item)} 
                        onChange={() => handleToggleSelect(index)} 
                      />
                    </td>
                    <td className="px-2 py-1 border border-black text-center">{item.ingredient_name} {item.eng_name ? `(${item.eng_name})` : ''}</td>
                    <td className="px-2 py-1 border border-black text-center">{item.ingredient_category_name}</td>
                    <td className="px-2 py-1 border border-black text-center">{item.order_qty}</td>
                    <td className="px-2 py-1 border border-black text-center">{item.order_pack_nos}</td>
                    <td className="px-0 py-1 border border-black text-center">
                      <input 
                        type="number" 
                        id="received_qty" 
                        name="received_qty" 
                        disabled={item.receipt_status === 3}
                        value={item?.received_qty ?? ''} 
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange(index)}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault(); // Disable up and down arrow keys
                          }
                        }} 
                        className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                      />
                      {item.receipt_status === 3 && 
                        <>
                          <button 
                            onClick={() => handleAddButtonClick(index)} 
                            className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                          >
                            &#x2b;
                          </button>
                          {item.add_received && 
                            <input 
                              type="number" 
                              id="add_received_qty" 
                              name="add_received_qty" 
                              value={item?.add_received_qty ?? ''} 
                              onWheel={(e) => e.target.blur()}
                              onChange={handleInputChange(index)}
                              onKeyDown={(e) => {
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                  e.preventDefault(); // Disable up and down arrow keys
                                }
                              }}
                              className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                            />
                          }
                        </>
                      }
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      <input 
                        type="number" 
                        id="rec_pack_nos" 
                        name="rec_pack_nos" 
                        disabled={item.receipt_status === 3}
                        value={item?.rec_pack_nos ?? 0} 
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange(index)}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault(); // Disable up and down arrow keys
                          }
                        }}                       
                        className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                      />
                    </td>
                    <td className={`px-2 py-1 border border-black text-center ${item.diff_qty < 0 ? 'bg-red-500 text-black' : ''}`}>{item.diff_qty}</td>
                    <td className={`px-2 py-1 border border-black text-center ${item.diff_pack < 0 ? 'bg-red-500 text-black' : ''}`}>{item.diff_pack}</td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item.receipt_status === 3 ? "Received" : "Pending Receipt"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            <div className='m-5'>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
              >
                Save
              </button>
              <button
                onClick={handleReceived}
                className="px-4 py-2 bg-rose-500 text-white rounded-md mr-4 hover:bg-rose-600 focus:outline-none focus:ring focus:ring-rose-200"
              >
                Received
              </button>
            </div>
          </div>
        )}
    </div>
  )
}

export default MainStoreReceiptList;